import { Features } from './Features';

export type { TypeFeaturesProps } from './types';
export default Features;
